var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-bell-circle.6f8732c8.png","uri@3x": __webpack_public_path__ + "icon-bell-circle.9d3cf7ed.png","uri@2x": __webpack_public_path__ + "icon-bell-circle.1231ba77.png",
    width: 129,
    height: 129
});